import React from "react";

const ProductFlagFilter = ({ filters, setFilters }) => {
  const toggle = (key) => {
    setFilters((prev) => ({
      ...prev,
      flags: {
        ...prev.flags,
        [key]: !prev.flags[key]
      }
    }));
  };

  return (
    <div className="space-y-3">
      <label className="flex items-center gap-2 text-sm cursor-pointer">
        <input
          type="checkbox"
          checked={filters.flags?.bestSeller || false}
          onChange={() => toggle("bestSeller")}
        />
        Best Sellers
      </label>

      <label className="flex items-center gap-2 text-sm cursor-pointer">
        <input
          type="checkbox"
          checked={filters.flags?.newArrivals || false}
          onChange={() => toggle("newArrivals")}
        />
        New Arrivals
      </label>
    </div>
  );
};

export default ProductFlagFilter;
